import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './Navbar';
import Hero from './Hero';
import TechPillars from './components/TechPillars';
import GenesisSection from './GenesisSection';
import CommunityCollaboration from './components/CommunityCollaboration';
import Footer from './Footer';
import AboutUs from './pages/AboutUs';
import Kanan from './pages/Kanan'; 
import Niya from './pages/Niya';
import Blebe from './pages/Blebe';
import BlebePrivacyPolicy from './pages/BlebePrivacyPolicy';
import Marchantite from './pages/Marchantite';
import { content } from './translations';
import './App.css';

const App = () => {
  const [lang, setLang] = useState('es');
  const [isDark, setIsDark] = useState(() => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });
  
  const t = content[lang];

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      setIsDark(e.matches);
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return (
    <Router>
      <div className={`min-h-screen transition-colors duration-700 font-sans overflow-x-hidden ${
        isDark ? 'bg-[#0A0F1A] text-white' : 'bg-[#F8FAFC] text-slate-900'
      }`}>
        
        <Navbar
          lang={lang}
          setLang={setLang}
          isDark={isDark}
          setIsDark={setIsDark}
          t={t}
        />

        <main className="relative z-10">
          <Routes>
            {/* RUTA PRINCIPAL (LANDING) */}
            <Route path="/" element={
              <>
                <Hero t={t} isDark={isDark} lang={lang} />
                <TechPillars isDark={isDark} lang={lang} />
                <GenesisSection t={t} isDark={isDark} lang={lang} />
                <CommunityCollaboration isDark={isDark} lang={lang} />
              </>
            } />

            <Route path="/nosotros" element={
              <AboutUs t={t} isDark={isDark} lang={lang} />
            } />

            <Route path="/proyectos/kanan" element={<Kanan t={t} isDark={isDark} />} />
            <Route path="/proyectos/Niya" element={<Niya t={t} isDark={isDark} />} />
            <Route path="/proyectos/Blebe" element={<Blebe t={t} isDark={isDark} />} />
            <Route path="/proyectos/Blebe/privacidad" element={<BlebePrivacyPolicy isDark={isDark} lang={lang} />} />
            <Route path="/proyectos/Marchantite" element={<Marchantite t={t} isDark={isDark} />} />

            {/* REDIRECCIÓN PARA RUTAS INEXISTENTES */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        <Footer t={t} isDark={isDark} lang={lang} />
      </div>
    </Router>
  );
};

export default App;